import { render, staticRenderFns } from "./ResearchVisits.vue?vue&type=template&id=1fe23fb6&scoped=true"
import script from "./ResearchVisits.vue?vue&type=script&lang=js"
export * from "./ResearchVisits.vue?vue&type=script&lang=js"
import style0 from "./ResearchVisits.vue?vue&type=style&index=0&id=1fe23fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe23fb6",
  null
  
)

export default component.exports